import React from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { key_icon } from '../../assets'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import { Link } from 'react-router-dom'
import { IoMdArrowBack } from 'react-icons/io'

import { 
    Container,
    InputContainer
 } from '../signup'



const NewPassword = () => {
  return (
    <Container>
        <NavBar/>
        <form >
            <img src={key_icon} alt="" />
            <h1>Set new password</h1>
            <p>Your new password must be different to previously used passwords.</p>
            
            <InputContainer>
                <label htmlFor="name">Password</label>
                <input name='password' type="password" placeholder='Enter new password' required />
                <small>Must be at least 8 characters.</small>
            </InputContainer>

            <InputContainer>
                <label htmlFor="cPassword">Confirm password</label>
                <input name='cPassword' type="password" placeholder='Confirm new password' required />
            </InputContainer>

            <CheckPassword>
                <Remember>
                    <input type="checkbox" name="" id="" />
                    <p>Remember Password</p>
                </Remember>

                <span> <Link to='/forgot-password' >Forgot Password?</Link></span>
            </CheckPassword>

            <Button filled bgColor={'#2A870E'} noIcon text={'Sign in'} />
        </form>

        <small>  <Link to='/login'> <IoMdArrowBack/> Back to log in</Link></small>
        
    </Container>
  )
}


const CheckPassword = styled.div`

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    & span{
        color: ${colors.secondary};
        font-weight: 500;
        font-size: 14px;

        & a{
            color: ${colors.secondary};
        }
    }
    
`

const Remember = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    & p{
        padding-left: 5px;
        font-size: 14px;
        font-weight: 500;
    }
`


export {NewPassword}